import { Box, Typography, useTheme } from "@mui/material";
import React from "react";
import profileImage from "../../../../../../../../media/images/profileImage.png";
import medalClub from "../../../../../../../../media/images/icons/medal_club.svg";
import KarenCoin from "../../../../../../../../media/images/icons/karenCoin.svg";
import RankingIcon from "../../../../../../../../media/images/icons/ranking-icon";
import { Link } from "react-router-dom";
import ArrowLeftSVG from "../../../../../../../../media/images/icons/arrow-left";

export default function UserInfoBox() {
  const theme = useTheme();
  return (
    <Box
      sx={{
        border: "1px solid gray",
        borderRadius: "8px",
        backgroundColor: "background.default",
        padding: "8px",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "start",
          justifyContent: "space-between",
        }}
      >
        <Box
          sx={{
            width: "50px",
            height: "50px",
            borderRadius: "50%",
            position: "relative",
          }}
        >
          <img
            style={{
              position: "absolute",
              bottom: "-4px",
              right: "4px",
            }}
            src={medalClub}
            alt=""
          />
          <img
            style={{
              width: "100%",
              height: "100%",
              borderRadius: "50%",
            }}
            src={profileImage}
            alt=""
          />
        </Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "4px",
            paddingX: "8px",
            paddingY: "8px",
            borderRadius: "8px",
            width: "fit-content",
            backgroundColor: "#424242",
          }}
        >
          <Typography color={"#FFD54F"}>کارن پوینت:</Typography>
          <Typography color={"#FFD54F"}>475</Typography>
          <img src={KarenCoin} alt="" />
        </Box>
      </Box>
      <Box
        sx={{
          mt: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Typography
          sx={{
            fontWeight: "600",
          }}
        >
          رضا یعقوبی‌فریان پور
        </Typography>
        <Box
          sx={{
            display: "flex",
            gap: "4px",
            alignItems: "center",
          }}
        >
          <RankingIcon color={theme.palette.secondary.main} />
          <img src={medalClub} alt="" />
          <Typography
            sx={{
              fontWeight: "600",
            }}
          >
            راننده جدید
          </Typography>
        </Box>
      </Box>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          mt: 1,
          gap: "16px",
        }}
      >
        <Box
          sx={{
            flex: 1,
            backgroundColor: "primary.light",
            display: "flex",
            flexDirection: "column",
            gap: "4px",
            borderRadius: "8px",
            paddingY: "8px",
            alignItems: "center",
            paddingX: "4px",
          }}
        >
          <Typography
            sx={{
              fontWeight: "600",
              color: "primary.main",
            }}
          >
            54
          </Typography>
          <Typography
            noWrap
            sx={{
              fontWeight: "600",
              color: "primary.main",
            }}
          >
            تکمیل ماموریت
          </Typography>
        </Box>
        <Box
          sx={{
            flex: 1,
            backgroundColor: "primary.light",
            display: "flex",
            flexDirection: "column",
            gap: "4px",
            borderRadius: "8px",
            paddingY: "8px",
            alignItems: "center",
            paddingX: "4px",
          }}
        >
          <Typography
            sx={{
              fontWeight: "600",
              color: "primary.main",
            }}
          >
            4
          </Typography>
          <Typography
            noWrap
            sx={{
              fontWeight: "600",
              color: "primary.main",
            }}
          >
            رتبه در لیگ
          </Typography>
        </Box>
        <Box
          sx={{
            flex: 1,
            backgroundColor: "primary.light",
            display: "flex",
            flexDirection: "column",
            gap: "4px",
            borderRadius: "8px",
            paddingY: "8px",
            alignItems: "center",
            paddingX: "4px",
          }}
        >
          <Typography
            sx={{
              fontWeight: "600",
              color: "primary.main",
            }}
          >
            59
          </Typography>
          <Typography
            noWrap
            sx={{
              fontWeight: "600",
              color: "primary.main",
            }}
          >
            جابجایی بار
          </Typography>
        </Box>
        <Box
          sx={{
            flex: 1,
            backgroundColor: "primary.light",
            display: "flex",
            flexDirection: "column",
            gap: "4px",
            borderRadius: "8px",
            paddingY: "8px",
            alignItems: "center",
            paddingX: "4px",
          }}
        >
          <Typography
            sx={{
              fontWeight: "600",
              color: "primary.main",
            }}
          >
            4.9
          </Typography>
          <Typography
            noWrap
            sx={{
              fontWeight: "600",
              color: "primary.main",
            }}
          >
            امتیاز
          </Typography>
        </Box>
      </Box>
      <Box
        sx={{
          mt: 2,

          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "4px",
          }}
        >
          <Typography
            sx={{
              fontSize: "12px",
              fontWeight: "600",
            }}
          >
            مزایا لیگ شما:
          </Typography>
          <Box
            sx={{
              backgroundColor: "secondary.light",
              display: "flex",
              alignItems: "center",
              gap: "4px",
              paddingY: "4px",
              paddingX: "8px",
              borderRadius: "4px",
            }}
          >
            <RankingIcon color={theme.palette.secondary.main} />
            <Typography
              sx={{
                color: "secondary.main",
                fontSize: "12px",
                fontWeight: "600",
              }}
            >
              10درصد تخفیف کارمزد
            </Typography>
          </Box>
        </Box>
        <Link
          to={"#"}
          style={{
            borderRadius: "4px",
            padding: "4px",
            borderColor: theme.palette.textColor.main,
            borderWidth: "1px",
            borderStyle: "solid",
            display: "flex",
            alignItems: "center",
          }}
        >
          <Typography
            sx={{
              color: "textColor.main",
              fontWeight: "600",
            }}
          >
            تاریخچه امتیازها
          </Typography>
          <ArrowLeftSVG size={20} color={theme.palette.textColor.main} />
        </Link>
      </Box>
    </Box>
  );
}
